import React from 'react';
export function Footer() {
  return <footer className="bg-footer text-gray-400 py-8 px-6 border-t border-white/5" data-id="element-124">
      <div className="max-w-6xl mx-auto text-center" data-id="element-125">
        <div className="mb-4" data-id="element-126">
          <h2 className="text-gold font-display text-2xl font-bold mb-1" data-id="element-127">
            💪 CHERUB AGENCY™
          </h2>
          <p className="text-white text-lg font-medium" data-id="element-128">
            El sistema de recursos N°1 para padres de niños con TDAH en España.
          </p>
        </div>

        <p className="italic mb-6 text-gray-500 max-w-2xl mx-auto" data-id="element-129">
          Porque criar a un hijo con TDAH no debería costarte cada noche de la
          semana.
        </p>

        <div className="flex flex-wrap justify-center gap-4 mb-6 text-sm" data-id="element-130">
          <a href="#" className="hover:text-gold transition-colors" data-id="element-131">
            📧 info@cherubagency.com
          </a>
          <span className="hidden md:inline" data-id="element-132">·</span>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-133">
            📲 @cherubagency
          </a>
          <span className="hidden md:inline" data-id="element-134">·</span>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-135">
            🌐 www.cherubagency.com
          </a>
        </div>

        <div className="text-xs text-gray-600 space-y-1" data-id="element-136">
          <p data-id="element-137">© Cherub Agency™ 2026 — Todos los derechos reservados.</p>
          <p data-id="element-138">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}